// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"94ab5075","453":"1e761eda"}[chunkId] + ".chunk.js";
};